import BlockContainer from "../Blocks/BlockContainer"
import PathContainer from "../Paths/PathContainer"
import { useCameraDispatchContext } from "../../contexts/CameraContext";
import { useRef } from "react";
import Panzoom from '../../lib/panzoom';
import './Camera.css';
import { useEffect, useState } from "react";
import ZoneBlockSelection from "../ZoneBlocksSelection/ZoneBlockSelection";
import Loader from '/src/components/loader/Loader'
import { useTreeStateContext } from '../../contexts/TreeContext';
import useBlockCamera from "../../hook/block/useBlockCamera";

// Camera component this component is responsible of handling the container who will display the block's and path's
// He will also dispatch the panzoom instance who will be needed to allow the user to move block's
// The trigger is place here because, it will reset the panzoom instance each time we change our bot
// That will clean the editor
function Camera () {

    const [ref, setRef] = useState()

    const elements = useRef(null);

    const dispatch = useCameraDispatchContext();

    const { fetching } = useTreeStateContext();

    const { followBlock } = useBlockCamera();

    useEffect(() => {

        var panzoom = null;
        if(fetching == true) {
            return;
        }

        // Todo put the panzoom config in a config file in the 'data' folder
        panzoom = Panzoom(elements.current, { 
            minZoom: 0.05, maxZoom: 2
        });
        dispatch( { type : 'loadCamera', payload : { panzoom }})
        
        // need to panzoom dispose if forget multiple instance will occured and nothing will work
        // The disposed instance stays in the camera context until the next one is loaded: flag it so the
        // hooks using the camera ignore it (see useCamera).
        return () => {
            panzoom.disposed = true;
            panzoom.dispose();
        };
    }, [fetching]);
    
    return (
        <>
        <div className="camera">
            { fetching == true && <Loader/>}
            <div ref={elements} className="elements">
                <BlockContainer/>
                <PathContainer/>
            </div>
            <ZoneBlockSelection/>
        </div>
        </>
    )
}

export default Camera;